import api from './api';

export const listAssets = async (projectId) => {
  if (!projectId) throw new Error('projectId is required');
  const { data } = await api.get(`/projects/${projectId}/assets`);
  return data;
};

export const createAsset = async (projectId, payload) => {
  if (!projectId) throw new Error('projectId is required');
  const { data } = await api.post(`/projects/${projectId}/assets`, payload);
  return data;
};

export const deleteAsset = async (projectId, assetId) => {
  if (!projectId || !assetId) throw new Error('projectId and assetId are required');
  const { data } = await api.delete(`/projects/${projectId}/assets/${assetId}`);
  return data;
};
